import React from "react";

import { Badge } from "@/components/atoms/Badge";
import { Text } from "@/components/atoms/Text";
import { Alert } from "@/components/molecules/Alert";

export const VendorAlert = () => {
  const handleAlertClick = () => {
    window.analyticsIntegrations.trackEvent("button clicked", {
      button_name: "vendors alert",
      button_location: "listing page",
      new_state: "vendors section",
    });
  };
  return (
    <a
      href="#vendors"
      onClick={handleAlertClick}
      className="tw-cursor-pointer tw-block"
    >
      <Alert
        appearance="purple"
        isDismissable={false}
        isVisible
        className="tw-shadow-xl tw-rounded-8 tw-border-none"
      >
        <div className="tw-mb-0 tw-flex tw-justify-between tw-items-center">
          <div className="tw-flex tw-gap-8 tw-items-center">
            <Badge appearance="purple" size="xs">
              <Text typeface="caption-1-b">NEW!</Text>
            </Badge>
            <span>
              <Text typeface="body-1-m" element="p">
                Complete your event. Discover trusted vendors in your area.
              </Text>
            </span>
          </div>
          <div>
            <Text typeface="body-1-m" className="tw-underline">
              Check out vendors
            </Text>
          </div>
        </div>
      </Alert>
    </a>
  );
};
